import { deleteRequest, get, post, patch } from "./api";

export const fetchPlaiditems = (customer_id) => {
  return get(`/api/v2/customers/${customer_id}/plaiditems/`);
};

export const fetchSubscription = (customer_id, params = {}) => {
  return get(`/api/v2/customers/${customer_id}/subscriptions/`, params);
};

export const cancelSubscription = (customer_id, subscription_id) => {
  return deleteRequest(
    `/api/v2/customers/${customer_id}/subscriptions/${subscription_id}/`
  );
};

export const addSubscription = (customer_id, data) => {
  return post(`/api/v2/customers/${customer_id}/subscriptions/`, data);
};

export const fetchSubscriptionSettings = () => {
  return get(`/api/v2/subscriptionsettings/`);
};

export const createBankAccount = (data) => {
  return post(`/api/v2/bankaccounts/`, data);
};

export const updateBankAccount = (id, data) => {
  return patch(`/api/v2/bankaccounts/${id}/`, data);
};

export const flipBankAccountSignConvention = (
  id,
  { new_convention, rerun_categorization } = {}
) => {
  return post(
    `/api/v2/bankaccounts/${id}/flip_sign_convention/`,
    {
      new_convention,
      rerun_categorization: Boolean(rerun_categorization),
    }
  );
};

export const fakePlaidImport = (formData) => {
  return post(`/api/v2/fake_plaid/`, formData, "multipart/form-data");
};

export const deletePlaidItem = (customer_id, plaiditem_id) => {
  return deleteRequest(`/api/v2/customers/${customer_id}/plaiditems/${plaiditem_id}/`);
};

export const updatePlaidItem = (customer_id, plaiditem_id, data) => {
  return patch(`/api/v2/customers/${customer_id}/plaiditems/${plaiditem_id}/`, data);
};
